/** For showing details like verified, platforms, tags e.t.c */

import {Directions} from 'common/components/drop-menu/types';
import {User} from 'common/report/queries/app-api/data-definitions-types';

export interface Detail {
  name: string;
  value: TODO;
  type?: DetailType;
}

export enum DetailType {
  TextHighlight = `text-hightlight`,
  User = `user`,
  BrowseLink = `browse-link`,
  Text = `text`,
}

/** For showing metrics like counts, num of users e.t.c */
export interface Metric {
  icon: string;
  value: string | number;
  tooltip: string;
  rank?: number;
  rankToolTip?: string;
}

export interface Action {
  name: string;
  label: string;
  icon?: string;
  item?: any;
  disabled?: boolean;
  href?: string;
  readonly?: boolean;
  disabledTooltipText?: string;
}

export interface EditItem {
  name?: string;
  type: string;
  id: string | number;
}

export interface Link {
  icon: string;
  href: string;
  tooltipText: string;
}

export interface CreatedBy {
  id: number;
  name: string;
  email: string;
}

export interface ImageInfo {
  imageUrl: string;
}

export interface ContextPanelData {
  header: string;
  subHeader?: string;
  path?: string[]; // A list of formatted items representing the nested accessors of the entity (i.g. [Users], [User, LookupProp], [LookupProp])
  entityType?: string;
  entityIcon?: string;
  entityReferencesCount?: number;
  entityName?: string;
  isUnsaved?: boolean;
  description: string;
  editItem?: EditItem;
  metrics?: Metric[];
  details?: Detail[];
  tags?: string[];
  queriedByUsers?: User[];
  extraInfo?: string[];
  excludedMetricIcons?: string[];
  links?: Link[];
  actions?: Action[];
  isRecentlyUsed?: boolean;
  placement?: Directions;
  hideMetricsSection?: boolean;
  imageInfo?: ImageInfo[];
  // Temporary values for roll out of multi attribution. Should be deleted.
  showNewForFreeUsers?: boolean;
  noteForFreeUsers?: string;
  noteForPaidUsers?: string;
}
